import React, { useState } from "react";
import AvailableSubscriptions from "./Tabs/AvailableSubscriptions";
import GroupSubscriptionInvoices from "./Tabs/GroupSubscriptionInvoices";
import GroupCurrentPlan from "./Tabs/GroupCurrentPlan";
import { TabConfig, TabKeys, URL_TAB_PARAM_KEY } from "./utils";
import useGetLanguage from "../../../utils/useGetLanguage";
import { LanguageText } from "../../../dictionary/GroupsText";
import { useSearchParams } from "react-router-dom";

const GroupSubscription: React.FC = () => {
  const language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });

  const [searchParams] = useSearchParams();
  const urlTab = searchParams.get(URL_TAB_PARAM_KEY);
  const [activeTabKey, setActiveTabKey] = useState<string>(
    urlTab && Object.values(TabKeys).includes(urlTab as TabKeys)
      ? urlTab
      : TabKeys.CURRENTPLAN
  );

  const tabs: TabConfig[] = [
    {
      key: TabKeys.CURRENTPLAN,
      label: language?.groupSubscription?.myPlan,
      component: <GroupCurrentPlan />,
    },
    {
      key: TabKeys.PLANS,
      label: language?.groupSubscription?.availablePlans,
      component: <AvailableSubscriptions />,
    },
    {
      key: TabKeys.INVOICES,
      label: language?.groupSubscription?.invoices,
      component: <GroupSubscriptionInvoices />,
    },
  ];
  const activeTab = tabs.find((tab) => tab.key === activeTabKey) || tabs[0];

  return (
    <div className="flex justify-center items-start w-full min-h-[60vh] px-2 py-4">
      <div className="w-full max-w-7xl bg-white rounded-xl shadow-lg overflow-hidden">
        {/* Tab Navigation */}
        <nav className="flex flex-col sm:flex-row w-full border-b border-gray-200 bg-gray-50">
          {tabs.map((tab, idx) => (
            <button
              key={tab.key}
              className={`flex-1 px-4 py-3 text-center font-semibold transition-all duration-200 focus:outline-none
                ${
                  activeTabKey === tab.key
                    ? "bg-white border-b-2 border-blue-600 text-blue-700 z-10"
                    : "bg-gray-50 text-gray-500 hover:bg-blue-50 hover:text-blue-700"
                }
                ${idx === 0 ? "rounded-tl-xl sm:rounded-tr-none" : ""}
                ${idx === tabs.length - 1 ? "rounded-tr-xl sm:rounded-tl-none" : ""}
              `}
              onClick={() => setActiveTabKey(tab.key)}
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </nav>
        {/* Tab Content */}
        <div className="p-2 sm:p-4 bg-white w-full">{activeTab.component}</div>
      </div>
    </div>
  );
};

export default GroupSubscription;
